module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('tag-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.editTag
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c915ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/tags/TagCreate.vue
// module id = 529
// module chunks = 0